var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 22.0026C6.48107 22.0026 2.00391 17.5255 2.00391 12.0026C2.00391 6.47984 6.48107 2.00269 12.0039 2.00269C17.5267 2.00269 22.0039 6.47984 22.0039 12.0026C22.0039 17.5255 17.5267 22.0026 12.0039 22.0026ZM12.0039 20.0026C16.4222 20.0026 20.0039 16.4209 20.0039 12.0026C20.0039 7.58441 16.4222 4.00269 12.0039 4.00269C7.58563 4.00269 4.00391 7.58441 4.00391 12.0026C4.00391 16.4209 7.58563 20.0026 12.0039 20.0026ZM12.0039 7.05294L16.9536 12.0026L12.0039 16.9524L7.05417 12.0026L12.0039 7.05294ZM12.0039 9.88137L9.88259 12.0026L12.0039 14.124L14.1252 12.0026L12.0039 9.88137Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0044 7.05322L16.9541 12.0029L12.0044 16.9527L7.05469 12.0029L12.0044 7.05322ZM12.0044 9.88165L9.88311 12.0029L12.0044 14.1243L14.1257 12.0029L12.0044 9.88165Z",
    fill: "#FAD228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.6ac4c091f967e765780b120c7c786af6.svg";
export { ForwardRef as ReactComponent };